import { Injectable } from '@angular/core';

import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { ISlip } from '../../../../../bet-generation/models';
import { GroupMinSelectionsError } from '../../../../errors/general/group-pick-error';
import { BetBuilderSlipValidationContext } from '../../../../models/models';
import { MINIMUM_BET_BUILDER_SELECTIONS } from '../../betslip/min-selections-betbuilder.validator';
import { IBetBuilderSlipValidator } from '../validators';

export const underMinimumGroupPickLegs = (pick: BaseBetslipGroupPick): boolean => {
    return pick.getLegs().length < MINIMUM_BET_BUILDER_SELECTIONS;
};

@Injectable()
export class MinSelectionsGroupPickSlipValidator implements IBetBuilderSlipValidator<GroupMinSelectionsError> {
    validate(_: ISlip, context: BetBuilderSlipValidationContext): GroupMinSelectionsError[] {
        const hasInvalidBetBuilderPicks = context.picks.some((p) => BaseBetslipGroupPick.isPick(p) && underMinimumGroupPickLegs(p));

        return hasInvalidBetBuilderPicks ? [new GroupMinSelectionsError()] : [];
    }
}
